import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import { navigateWithScrollReset } from '../../utils/ScrollRestoration';

const MobileBottomNavigation = ({ isAdmin, contentRef }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Define navigation items based on role
    // For Admins: Finance (Balance) first, then Renewals
    // For Staff: Renewals first, then Finance (Balance)
    const navItems = isAdmin
        ? [
            { id: 'balance', label: 'Finance', icon: <AccountBalanceWalletIcon />, path: '/balance' },
            { id: 'renewals', label: 'Renewal', icon: <AutorenewIcon />, path: '/renewals' },
            { id: 'client', label: 'Client', icon: <PeopleIcon />, path: '/client' },
            { id: 'policy', label: 'Policy', icon: <DescriptionIcon />, path: '/policy' },
        ]
        : [
            { id: 'renewals', label: 'Renewal', icon: <AutorenewIcon />, path: '/renewals' },
            { id: 'balance', label: 'Balance', icon: <AccountBalanceWalletIcon />, path: '/balance' },
            { id: 'client', label: 'Client', icon: <PeopleIcon />, path: '/client' },
            { id: 'policy', label: 'Policy', icon: <DescriptionIcon />, path: '/policy' },
        ];

    return (
        <Box
            className="bottom-navigation"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                px: 0.5,
                py: 1,
                height: 80,
                backgroundColor: 'white',
                borderTop: '1px solid #e0e0e0',
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000
            }}
        >
            {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                    <Box
                        key={item.id}
                        onClick={() => navigateWithScrollReset(navigate, item.path, contentRef)}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            cursor: 'pointer',
                            py: 0.5,
                            '&:active': {
                                transform: 'none',
                                backgroundColor: 'transparent'
                            },
                            transition: 'none',
                            WebkitTapHighlightColor: 'transparent'
                        }}
                    >
                        {React.cloneElement(item.icon, {
                            sx: {
                                color: isActive ? '#0063F7' : '#757575',
                                mb: 0.5,
                                fontSize: 20
                            }
                        })}
                        <Typography
                            sx={{
                                fontSize: '9px',
                                color: isActive ? '#0063F7' : '#757575',
                                fontWeight: isActive ? 500 : 400,
                                letterSpacing: '-0.02em'
                            }}
                        >
                            {item.label}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default MobileBottomNavigation;
